/* eslint-disable max-len */
import React from 'react'
import { FormattedMessage } from 'react-intl'

import { RESERVE_TYPES } from 'constants'


export const RESERVE_DESCRIPTIONS = {
    [RESERVE_TYPES.REQUISITION]: (
        <FormattedMessage
            id='construct.reserve_descriptions.requisition'
            defaultMessage='Дополнительный промресурс в зависимости от уровня резерва.'
        />
    ),
    [RESERVE_TYPES.BATTLE_PAYMENTS]: (
        <FormattedMessage
            id='construct.reserve_descriptions.battle_payments'
            defaultMessage='Дополнительные кредиты в зависимости от уровня резерва.'
        />
    ),
    [RESERVE_TYPES.TACTICAL_TRAINING]: (
        <FormattedMessage
            id='construct.reserve_descriptions.tactical_training'
            defaultMessage='Дополнительный боевой опыт в зависимости от уровня резерва.'
        />
    ),
    [RESERVE_TYPES.ARTILLERY_STRIKE]: (
        <FormattedMessage
            id='construct.reserve_descriptions.artillery_strike'
            defaultMessage='Вызов артудара и дополнительный промресурс в Вылазках и при Наступлениях на 1 бой'
        />
    ),
    [RESERVE_TYPES.MILITARY_MANEUVERS]: (
        <FormattedMessage
            id='construct.reserve_descriptions.military_maneuvers'
            defaultMessage='Дополнительный свободный опыт в зависимости от уровня резерва.'
        />
    ),
    [RESERVE_TYPES.AIRSTRIKE]: (
        <FormattedMessage
            id='construct.reserve_descriptions.airstrike'
            defaultMessage='Вызов авиаудара и дополнительный промресурс при вызове авиаудара'
        />
    ),
    [RESERVE_TYPES.ADDITIONAL_BRIEFING]: (
        <FormattedMessage
            id='construct.reserve_descriptions.additional_briefing'
            defaultMessage='Дополнительный опыт экипажа в зависимости от уровня резерва.'
        />
    ),
    [RESERVE_TYPES.HIGH_CAPACITY_TRANSPORT]: (
        <FormattedMessage
            id='construct.reserve_descriptions.high_capacity_transport'
            defaultMessage='Дополнительный промресурс в зависимости от уровня резерва.'
        />
    ),
    [RESERVE_TYPES.INSPIRATION]: (
        <FormattedMessage
            id='construct.reserve_descriptions.inspiration'
            defaultMessage='Бонус к основным специальностям и всем умениям экипажа машины игрока с Воодушевлением и ближайших союзников, а также дополнительный промресурс в Вылазках и при Наступлениях на 1 бой'
        />
    ),
}

export const CONSTRUCT_HEADERS = {
    title: (
        <FormattedMessage
            id='construct.construct_headers.title'
            defaultMessage='Выберите строение, которое хотите возвести'
        />
    ),
    title_no_permission: (
        <FormattedMessage
            id='construct.construct_headers.title_no_permission'
            defaultMessage='Невозведённые строения'
        />
    ),
}

export const PERMISSION_WARNING = (
    <FormattedMessage
        id='construct.permission_warning'
        defaultMessage='Возвести строение могут командующий и его заместители.'
    />
)

export const CONSTRUCTION_COST = (
    <FormattedMessage
        id='construct.construction_cost'
        defaultMessage='Стоимость'
    />
)

export const BUILD_BUTTON_CAPTION = (
    <FormattedMessage
        id='construct.build_button_caption'
        description='Надпись на кнопке на странице постройки зданий'
        defaultMessage='Построить'
    />
)

export const NOT_ENOUGH_TOOLTIP_ID = 'not_enough_tooltp_id'



// WEBPACK FOOTER //
// ./containers/Construct/constants.jsx